// Lampinaire : la page produit « 2.0 » (modèle product.octo, V2.4.3). Chargé UNE fois par le gabarit, en module.

// Curseur avant / après : le champ invisible (clavier compris) déplace la ligne et la poignée.
for (const box of document.querySelectorAll('[data-octo-avant-apres]')) {
  const input = box.querySelector('input[type="range"]');
  if (!input) continue;
  const update = () => box.style.setProperty('--position', `${input.value}%`);
  input.addEventListener('input', update);
  update();
}

// Cartes « où la placer » sur téléphone : un point par carte, le point de la carte visible est mis en avant.
for (const grille of document.querySelectorAll('[data-octo-cartes]')) {
  const cartes = [...grille.children];
  const points = grille.parentElement?.querySelector('[data-octo-points]');
  if (!points || cartes.length < 2) continue;
  points.innerHTML = cartes.map(() => '<span></span>').join('');
  const marques = [...points.children];
  const actualiser = () => {
    const pas = cartes[1].offsetLeft - cartes[0].offsetLeft || 1;
    const rang = Math.min(cartes.length - 1, Math.max(0, Math.round(grille.scrollLeft / pas)));
    marques.forEach((m, i) => m.toggleAttribute('data-actif', i === rang));
  };
  grille.addEventListener('scroll', () => requestAnimationFrame(actualiser), { passive: true });
  actualiser();
}

// Livraison estimée : la date du jour plus les jours ouvrés annoncés (samedis et dimanches exclus), calculée dans le
// navigateur pour rester juste même si la page est en cache (« entre le 28 oct. et le 5 nov. »). Sans script, la
// phrase « en 6 à 12 jours ouvrés » reste.
const addBusinessDays = (from, days) => {
  const date = new Date(from);
  let left = days;
  while (left > 0) {
    date.setDate(date.getDate() + 1);
    const day = date.getDay();
    if (day !== 0 && day !== 6) left -= 1;
  }
  return date;
};
const formatter = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short' });
// Espaces insécables : « 6 nov. » ne se coupe jamais en fin de ligne.
const format = { format: (date) => formatter.format(date).replace(/ /g, ' ') };
for (const el of document.querySelectorAll('[data-octo-livraison]')) {
  const min = Number(el.dataset.min);
  const max = Number(el.dataset.max);
  const target = el.querySelector('[data-octo-livraison-texte]');
  if (!target || !Number.isFinite(min) || !Number.isFinite(max) || min <= 0 || max < min) continue;
  const now = new Date();
  // Le texte en gras vient du réglage du bloc (« Livraison offerte », « Livrée »…) : inséré comme texte, jamais comme HTML.
  const gras = document.createElement('strong');
  gras.textContent = el.dataset.titre || (el.dataset.offerte === 'true' ? 'Livraison offerte' : 'Livrée');
  const debut = el.dataset.offerte === 'true' ? ', du' : ' entre le';
  const lien = el.dataset.offerte === 'true' ? 'au' : 'et le';
  target.replaceChildren(gras, `${debut} ${format.format(addBusinessDays(now, min))} ${lien} ${format.format(addBusinessDays(now, max))}`);
}

// Un lien vers un volet (« Retours sous 14 jours » → volet Retours) l'ouvre avant d'y descendre.
for (const lien of document.querySelectorAll('a[data-octo-ouvrir]')) {
  lien.addEventListener('click', () => {
    const volet = document.querySelector(lien.getAttribute('href'));
    if (volet instanceof HTMLDetailsElement) volet.open = true;
  });
}

// Barre d'achat collante : Horizon la masque dès qu'un chat Shopify existe sur la page, même rangé dans son tiroir
// fermé (aucune bulle à l'écran ; le chat est ajouté après le chargement). Sur ce modèle (V2.9.6, règle du 24 octobre
// 2026), elle ne s'affiche qu'une fois le bouton d'achat principal sorti de l'écran par le haut, jamais dès l'arrivée sur
// la page (même quand le bouton est encore plus bas que le premier écran), et se cache près du pied de page ou quand le
// tiroir du chat est ouvert.
// Calculée au défilement (un saut d'ancre ne déclencherait pas toujours un observateur d'intersection).
const buyButtons = document.querySelector('product-form-component')?.closest('.buy-buttons-block');
if (document.querySelector('sticky-add-to-cart') && buyButtons) {
  let pending = false;
  const update = () => {
    pending = false;
    const bar = document.querySelector('sticky-add-to-cart [ref="stickyBar"]');
    if (!bar) return;
    const zone = buyButtons.getBoundingClientRect();
    const buyGone = zone.bottom < 0;
    const footer = document.querySelector('footer');
    const nearFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight + 200 : false;
    const chatOpen = Boolean(document.querySelector('shopify-chat')?.closest('dialog[open]'));
    const stuck = String(buyGone && !nearFooter && !chatOpen);
    if (bar.dataset.stuck !== stuck) bar.dataset.stuck = stuck;
  };
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  };
  window.addEventListener('scroll', schedule, { passive: true });
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('resize', schedule);
  update();
}
